module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-address"
  }, [_c('p', [_vm._v("成都和容兴邦广告有限公司")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.webinfo.name))]), _vm._v(" "), _c('p', [_vm._v("地址：" + _vm._s(_vm.webinfo.address))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4339f56b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Address.vue
// module id = 175
// module chunks = 1